import { __assign, __rest } from "tslib";
import React from 'react';
var ArrowTop = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement("svg", __assign({ width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M6.37103 14.6631C5.53034 14.6631 5.06485 13.6887 5.59309 13.0347L9.40755 8.31208C10.0079 7.56876 11.141 7.56876 11.7414 8.31208L15.5558 13.0347C16.0841 13.6887 15.6186 14.6631 14.7779 14.6631H6.37103Z", fill: "#222426" })));
};
export default ArrowTop;
//# sourceMappingURL=ArrowTop.js.map